'use strict';

module.exports = function(angular, app) {
	app.service('integrationsService', [function() {

		const partnerSettingsSchema = {
			sas: {
				name: 'Smart AdServer',
				properties: {
					serverLocation: {
						type: 'select',
						label: 'Server Location',
						options: [
							{
								label: 'Europe',
								value: 'EU',
							},
							{
								label: 'USA',
								value: 'US',
							},
							{
								label: 'Sandbox',
								value: 'sandbox',
							},
						],
					},
					clientId: {
						type: 'input',
						label: 'Client ID',
					},
					clientSecret: {
						type: 'input',
						label: 'Secret Key',
					},
					publicSegmentProviderId: {
						type: 'input',
						label: 'Segment Provider ID',
					},
				},
			},
		};

		// GET ALL PARTNER SETTINGS SCHEMA
		// returns an object with available partners settings (labels, props)
		const getAllPartnerSettingsSchema = () => partnerSettingsSchema;

		// GET PARTNER SETTINGS SCHEMA
		// returns an object with partner label and properties
		const getPartnerSettingsSchemaSchema = partnerId => partnerSettingsSchema[partnerId] || {};

		return {
			getAllPartnerSettingsSchema: getAllPartnerSettingsSchema,
			getPartnerSettingsSchemaSchema: getPartnerSettingsSchemaSchema,
		};

	}]);
};
